import { render, staticRenderFns } from "./TablePaginator.vue?vue&type=template&id=5b605032"
import script from "./TablePaginator.vue?vue&type=script&lang=js"
export * from "./TablePaginator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports